// Loader.js
import React, { useEffect, useState } from "react";

const Loader = () => {
  const [progress, setProgress] = useState(0);
  const [hide, setHide] = useState(false);

  useEffect(() => {
    let current = 0;
    const totalDuration = 3000; // 3 seconds
    const intervalTime = 30;
    const increment = 100 / (totalDuration / intervalTime);

    const easeOutQuart = t => 1 - Math.pow(1 - t, 4);

    const timer = setInterval(() => {
      current += increment;
      if (current >= 100) current = 100;

      setProgress(easeOutQuart(current / 100) * 100);

      if (current === 100) {
        clearInterval(timer);
        setTimeout(() => setHide(true), 500); // fade out delay
      }
    }, intervalTime);
  }, []);

  if (hide) return null;

  return (
    <div className="loader-wrapper" id="loader">
      <div className="loader-content">
        <img
          src="/images/logo.png"
          alt="Loading..."
          className="loader-logo"
        />
        <div className="loader-text">Loading...</div>
        <div className="loader-progress">
          <div
            className="loader-progress-bar"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
        <div className="loader-percentage">{Math.round(progress)}%</div>
      </div>
    </div>
  );
};

export default Loader;
